var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe 3122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad 3809",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.362 16.2663C1.12927 16.2629 0.124274 15.2582 0.121094 14.027V3.20465C0.124264 1.97195 1.12927 0.967347 2.36059 0.963867H2.36199H16.7889C18.022 0.967347 19.0267 1.97196 19.0298 3.20328V14.0255C19.0267 15.2582 18.022 16.2629 16.7904 16.2663H2.362ZM2.36346 1.83836C1.61102 1.8405 0.997744 2.45402 0.995664 3.2061V14.0255C0.997744 14.7763 1.61102 15.3898 2.36346 15.3919H16.7889C17.54 15.3897 18.1533 14.7763 18.1553 14.0241V3.20466C18.1533 2.45402 17.54 1.84049 16.7875 1.83836H2.36346Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad 3810",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57608 11.2992C9.48025 11.2992 9.38431 11.2678 9.30496 11.2048L0.287049 4.07335C0.0977789 3.92323 0.0656089 3.6483 0.215329 3.45906C0.365419 3.26979 0.639889 3.23729 0.829529 3.38737L9.57608 10.3044L18.3218 3.38737C18.5114 3.23762 18.7859 3.27012 18.9361 3.45906C19.0857 3.6483 19.0536 3.92323 18.8644 4.07335L9.84708 11.2048C9.76773 11.2678 9.67191 11.2992 9.57608 11.2992Z",
    fill: "#383838"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.938ba2510a4a2ec10bcc113d8e4bcbf7.svg";
export { ForwardRef as ReactComponent };